import { create } from "zustand";
import { ShopifyProduct } from "@/lib/shopify";

interface CompareState {
  items: ShopifyProduct[];
  add: (product: ShopifyProduct) => void;
  remove: (id: string) => void;
  clear: () => void;
  has: (id: string) => boolean;
}

export const useCompareStore = create<CompareState>((set, get) => ({
  items: [],
  add: (product) => {
    const { items } = get();
    if (items.length >= 4) return;
    if (items.some((p) => p.node.id === product.node.id)) return;
    set({ items: [...items, product] });
  },
  remove: (id) => set((s) => ({ items: s.items.filter((p) => p.node.id !== id) })),
  clear: () => set({ items: [] }),
  has: (id) => get().items.some((p) => p.node.id === id),
}));
